import { connect } from "react-redux";
import AddNewBoradcast from "./newbroadcast";
import { SubmitBroadcastRequst } from "../../../redux/actions/broadcast/submitbroadcast.action";
import { openAlertPopup } from "../../../redux/actions/Alert/alert.action";
import { getBroadcastList } from "../../../redux/actions/broadcast/broadcastList.action";
import { SubmitUpdateBroadcast } from "../../../redux/actions/broadcast/submitUpdatebroadcast.action";
import { SubmitstopBroadcast } from "../../../redux/actions/broadcast/broadcastStop.action";

const mapStateToProps = (state) => {
    return {
    
    } 
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      SubmitBroadcastRequst: (payload) => {
        return dispatch(SubmitBroadcastRequst(payload))
      }, 
      SubmitUpdateBroadcast: (payload,id) => {
        return dispatch(SubmitUpdateBroadcast(payload,id))
      },
      SubmitstopBroadcast: (payload,id) => {
        return dispatch(SubmitstopBroadcast(payload,id))
      }, 
      openAlertPopup: (payload) => {
        return dispatch(openAlertPopup(payload))
      },
      getBroadcastList: (next=null,status="",orderBy="")=>{
        return dispatch(getBroadcastList(next=null,status,orderBy))
    },
    }
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(AddNewBoradcast);


